import classNames from 'classnames';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { YouTubePlayer, YouTubePlayerProps } from './youtube-player';
import { AdvertEmbeddedComponent } from 'components/advert/advert-embedded-component';

export const YouTubeVideoEntry = ({ isDrawer, config, modulePath }: IModule<YouTubePlayerProps>) => {
  const { key, advert, ...restConfig } = config;
  if (!config.playlist?.id) return null;
  return (
    <Tile dataModule="video-youtube" config={config} classes="Tile--whiteBackground">
      <div className={classNames('Tile-body', { 'Tile-body--noPadding': isDrawer })}>
        <TileBodyHeaderV2
          isDrawer={isDrawer}
          modulePath={modulePath}
          config={{ ...config, title: config.playlist.title ?? config.title }}
          trackingOrigin='video_forecast'
        />
        <YouTubePlayer key={key} {...restConfig} />
      </div>
      <AdvertEmbeddedComponent
        {...advert}
      />
    </Tile>
  );
};
